export default "__VITE_ASSET__BgqN6Rzl__"